<template>
  <v-app id="updHsfp">  
    <defNavBar title="Ares - LOS prices" :actions="hspt.action_items" :home="true" @actionClick="actionClick"/>
    <v-main>
      <div v-if="!loading">
        <v-card class="ma-2">
          <span class="px-2">Accomdation: {{hspt.huis_code}} </span>
          <span class="px-2">Status: {{hspt.stat_code}} </span>
          <span class="px-10">Arrival: {{hspt.hspt_aank_van_dat}} / {{hspt.hspt_aank_tm_dat}} </span>
        </v-card>
        <v-container fluid>
          <v-simple-table fixed-header height="800px" dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Arrival</th>
                  <th>Departure</th>
                  <th style="text-align:right">Rental price</th>
                  <th style="text-align:right">Renting price</th>
                  <th style="text-align:right">Margin</th>
                  <th>Num days before stay</th>
                  <th><v-tooltip bottom><template v-slot:activator="{ on }"><span v-on="on">Planning</span></template><span>0 = Bookable, on contract<br>2 = Not bookable, not on contract<br>3 = Not bookable, on contract<br>4 = Bookable, on contract, not in price extension</span></v-tooltip></th>                
                  <th>User</th>
                  <th>Last changed</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>            
                <tr v-for="(hsfp,i) in hspt.hsfp" :key="i">  
                <td @click="upd1Hsfp(hsfp.hsfp_encrid)">{{hsfp.hsfp_van_dat}}</td>
                <td @click="upd1Hsfp(hsfp.hsfp_encrid)">{{hsfp.hsfp_tm_dat}}</td>
                <td align="right" @click="upd1Hsfp(hsfp.hsfp_encrid)">{{hsfp.hsfp_inkoop}}</td>
                <td align="right" @click="upd1Hsfp(hsfp.hsfp_encrid)">{{hsfp.hsfp_verkoop}}</td> 
                <td align="right" @click="upd1Hsfp(hsfp.hsfp_encrid)">{{hsfp.hsfp_margin}} %</td> 
                <td @click="upd1Hsfp(hsfp.hsfp_encrid)">{{hsfp.hsfp_advb}} </td>
                <td @click="upd1Hsfp(hsfp.hsfp_encrid)">{{hsfp.hsfp_planning}} </td>
                <td @click="upd1Hsfp(hsfp.hsfp_encrid)">{{hsfp.gebr_code}} </td>
                <td @click="upd1Hsfp(hsfp.hsfp_encrid)">{{hsfp.hsfp_dt}} </td> 
                <td><v-btn text icon  @click="rm1Hsfp(hsfp.hsfp_encrid)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn></td> 
                </tr>
              </tbody>
              <upd1Hsfp ref="upd1Hsfp"></upd1Hsfp>
              <excelExportHsfp ref="excelExportHsfp"></excelExportHsfp>
              <excelImportHsfp ref="excelImportHsfp"></excelImportHsfp>
              <rmHsfp ref="rmHsfp"></rmHsfp>
              <rm1Hsfp ref="rm1Hsfp"></rm1Hsfp>
            </template>
          </v-simple-table>
        </v-container>
      </div>
      <div v-else>
        <v-row class="mt-10">
          <v-col cols="12" span="12" align="center">
            <v-progress-circular :width="3" :size="25" color="green" indeterminate></v-progress-circular>
            <span class="markup ml-4">loading LOS prices, this may take some time...</span>
          </v-col>
        </v-row>  
      </div>      
    </v-main>  
  </v-app>
</template>

<script>

import { bus } from "../../../../main";

import upd1Hsfp from "@/views/huis/hspt/hsfp/upd1Hsfp.vue";
import excelExportHsfp from "@/views/huis/hspt/hsfp/excelExportHsfp.vue";
import excelImportHsfp from "@/views/huis/hspt/hsfp/excelImportHsfp.vue";
import rmHsfp from "@/views/huis/hspt/hsfp/rmHsfp.vue";
import rm1Hsfp from "@/views/huis/hspt/hsfp/rm1Hsfp.vue";
import defNavBar from '@/components/ui/navbars/navbar.vue';

export default {
  components: {
    upd1Hsfp,
    excelExportHsfp,
    excelImportHsfp,
    rmHsfp,
    rm1Hsfp,
    defNavBar
  },
  props: ['hspt_encrid'],
  data() {
    return {
      hspt: {
        action_items: [],  /* moet pre defined ivm length check */
      },
      loading: true
    }

  },
  created() {
    bus.$on("closeDialog", (data) => {
      console.log(data);
      if (data === 'reload') {
        this.getHsptLosPrices();
      }
    });
  },
  mounted() {
    this.getHsptLosPrices();
  },
  methods: {
    getHsptLosPrices() {
      this.$axios
        .post("ares/json/ares/huis/hspt/hsfp/getHspt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHspt"
          },
          getHspt: {
            hspt_encrid: this.hspt_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
            this.loading = false;
          } else {
            this.hspt = res.data.getHspt;
            this.loading = false;
          }
        });
    },
    upd1Hsfp(hsfp_encrid) {
      this.$refs.upd1Hsfp.open(hsfp_encrid);
    },
    rm1Hsfp(hsfp_encrid) {
      this.$refs.rm1Hsfp.open(hsfp_encrid);
    },
    actionClick(action) {
      if (action == "excelExport") {
        this.$refs.excelExportHsfp.open(this.hspt_encrid);
      }
      if (action == "excelImport") {
        this.$refs.excelImportHsfp.open(this.hspt_encrid);
      }
      if (action == "rmHsfp") {
        this.$refs.rmHsfp.open(this.hspt_encrid);
      }
    }
  }
};
</script> 
